import type { QueryClient } from '@tanstack/react-query';
import { SHUTDOWN_STATUS_QUERY_KEY } from '../shutdown/api';

export const clearUserScopedQueryState = (queryClient: QueryClient) => {
  queryClient.removeQueries({
    predicate: (query) => query.queryKey[0] !== SHUTDOWN_STATUS_QUERY_KEY[0],
  });
  queryClient.getMutationCache().clear();
};
